module.exports = __webpack_public_path__ + "static/img/bg-ar.c11f521e.png";